export default function handleDocumentClick(event) {
  event.preventDefault()
  event.stopPropagation()

  window.modalCitizen.openModal('export-select-from-documents-modal', {
    exportElementId: event.target.closest('h4').id,
  })
}
